import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./layout.css";
import { Link } from "react-router-dom";

const Navbar = ({ isSidebarOpen, closeSidebar }) => {
  const sidebarRef = useRef(null);
  const [isInstitutionsOpen, setIsInstitutionsOpen] = useState(false);
  const [isUsersOpen, setIsUsersOpen] = useState(false);
  const [isPackagesOpen, setIsPackagesOpen] = useState(false); // Separate state for Packages
  const [isMasterDataOpen, setIsMasterDataOpen] = useState(false);
  const [isItineraryOpen, setIsItineraryOpen] = useState(false);
  const [isContentOpen, setIsContentOpen] = useState(false);
  const [role, setRole] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    // Get user role from localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setRole(user.role);
    }

    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeSidebar]);

  const renderUsersTab = () => (
    <li>
      <button
        className="navbar-item text-base font-normal text-gray-900 w-full text-left"
        onClick={() => setIsUsersOpen(!isUsersOpen)}
      >
        <span className="material-symbols-outlined">person</span>
        <span className="ml-3">Users</span>
        <span className="material-symbols-outlined ml-auto">
          {isUsersOpen ? "expand_less" : "expand_more"}
        </span>
      </button>
      {isUsersOpen && (
        <ul className="pl-8 space-y-2">
          <li>
            <Link
              to="/users"
              className="navbar-item text-base font-normal text-gray-900"
              onClick={closeSidebar}
            >
              All Users
            </Link>
          </li>
          <li>
            <Link
              to="/add-user"
              className="navbar-item text-base font-normal text-gray-900"
              onClick={closeSidebar}
            >
              Add User
            </Link>
          </li>
        </ul>
      )}
    </li>
  );

  const renderInstitutionsTab = () => (
    <li>
      <button
        className="navbar-item text-base font-normal text-gray-900 w-full text-left"
        onClick={() => setIsInstitutionsOpen(!isInstitutionsOpen)}
      >
        <span className="material-symbols-outlined">apartment</span>
        <span className="ml-3">Institutions</span>
        <span className="material-symbols-outlined ml-auto">
          {isInstitutionsOpen ? "expand_less" : "expand_more"}
        </span>
      </button>
      {isInstitutionsOpen && (
        <ul className="pl-8 space-y-2">
          <li>
            <Link
              to="/institutions"
              className="navbar-item text-base font-normal text-gray-900"
              onClick={closeSidebar}
            >
              All Institutions
            </Link>
          </li>
          {(role === "Admin" || role === "Sales Manager") && (
            <li>
              <Link
                to="/add-institutions"
                className="navbar-item text-base font-normal text-gray-900"
                onClick={closeSidebar}
              >
                Add Institution
              </Link>
            </li>
          )}
        </ul>
      )}
    </li>
  );

  const renderItineraryTab = () => (
    <li>
      <button
        className="navbar-item text-base font-normal text-gray-900 w-full text-left"
        onClick={() => setIsItineraryOpen(!isItineraryOpen)}
      >
        <span className="material-symbols-outlined">
          distance
        </span>
        <span className="ml-3">Itinerary</span>
        <span className="material-symbols-outlined ml-auto">
          {isItineraryOpen ? "expand_less" : "expand_more"}
        </span>
      </button>
      {isItineraryOpen && (
        <ul className="pl-8 space-y-2">
          <li>
            <Link
              to="/all-itinerary"
              className="navbar-item text-base font-normal text-gray-900"
              onClick={closeSidebar}
            >
              All Itinerary
            </Link>
          </li>
          {user?.role === "Admin" && (
            <li>
              <Link
                to="/add-itinerary"
                className="navbar-item text-base font-normal text-gray-900"
                onClick={closeSidebar}
              >
                Add Itinerary
              </Link>
            </li>
          )}
        </ul>
      )}
    </li>
  );

  const renderContentTab = () => (
    <li>
      <button
        className="navbar-item text-base font-normal text-gray-900 w-full text-left"
        onClick={() => setIsContentOpen(!isContentOpen)}
      >
        <span className="material-symbols-outlined">web</span>
        <span className="ml-3">Content</span>
        <span className="material-symbols-outlined ml-auto">
          {isContentOpen ? "expand_less" : "expand_more"}
        </span>
      </button>
      {isContentOpen && (
        <ul className="pl-8 space-y-2">
          <li>
            <Link
              to="/homepage-cms"
              className="navbar-item text-base font-normal text-gray-900"
              onClick={closeSidebar}
            >
              Homepage CMS
            </Link>
          </li>
        </ul>
      )}
    </li>
  );

  return (
    <>
      {isSidebarOpen && (
        <>
          <div
            className="fixed inset-0 bg-black opacity-50 z-30"
            onClick={closeSidebar}
          ></div>
          <div
            ref={sidebarRef}
            id="drawer-navigation"
            className="fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform translate-x-0 bg-white w-64 light:bg-white-800"
            tabIndex="-1"
            aria-labelledby="drawer-navigation-label"
          >
            <Link to="/" onClick={closeSidebar}>
              <img
                src="https://crm.fuelifeexplorers.com/crmImages/logo/1680004129Fuelife-Explorers.png"
                className="react h-[50px]"
                alt="React logo"
              />
            </Link>
            <div className="py-4 overflow-y-auto">
              <ul className="space-y-2">
                {/* Dashboard Item */}
                <li>
                  <Link
                    to="/dashboard"
                    className="navbar-item text-base font-normal text-gray-900"
                    onClick={closeSidebar}
                  >
                    <span className="material-symbols-outlined">
                      stacked_bar_chart
                    </span>{" "}
                    <span className="ml-3">Dashboard</span>
                  </Link>
                </li>


                {renderInstitutionsTab()}
                {/* Packages Item */}
                <li>
                  <button
                    className="navbar-item text-base font-normal text-gray-900 w-full text-left flex items-center"
                    onClick={() => setIsPackagesOpen(!isPackagesOpen)}
                  >
                    <span className="material-symbols-outlined">
                      move
                    </span>
                    <span className="ml-3">Packages</span>
                    <span className="material-symbols-outlined ml-auto">
                      {isPackagesOpen ? "expand_less" : "expand_more"}
                    </span>
                  </button>
                  {isPackagesOpen && (
                    <ul className="pl-8 space-y-2">
                      <li>
                        <Link
                          to="/all-packages"
                          className="navbar-item text-base font-normal text-gray-900"
                          onClick={closeSidebar}
                        >
                          All Packages
                        </Link>
                      </li>
                      {user?.role === "Admin" && (
                        <li>
                          <Link
                            to="/add-packages"
                            className="navbar-item text-base font-normal text-gray-900"
                            onClick={closeSidebar}
                          >
                            Add Packages
                          </Link>
                        </li>
                      )}
                      {user?.role === "Admin" && (
                        <li>
                          <button
                            className="navbar-item text-base font-normal text-gray-900 w-full text-left flex items-center"
                            onClick={() => setIsMasterDataOpen(!isMasterDataOpen)}
                          >
                            Master Data
                            <span className="material-symbols-outlined ml-auto">
                              {isMasterDataOpen ? "expand_less" : "expand_more"}
                            </span>
                          </button>
                          {isMasterDataOpen && (
                            <ul className="pl-6 space-y-2">
                              <li>
                                <Link
                                  to="/hotels"
                                  className="navbar-item text-base font-normal text-gray-900"
                                  onClick={closeSidebar}
                                >
                                  Properties
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/transportation"
                                  className="navbar-item text-base font-normal text-gray-900"
                                  onClick={closeSidebar}
                                >
                                  Transportation
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/addons"
                                  className="navbar-item text-base font-normal text-gray-900"
                                  onClick={closeSidebar}
                                >
                                  Addons
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      )}
                    </ul>
                  )}
                </li>

                {/* Institutions Item */}

                {renderItineraryTab()}
                {role === "Admin" && renderContentTab()}
                <li>
                  <Link
                    to="/assigned-institution"
                    className="navbar-item text-base font-normal text-gray-900"
                    onClick={closeSidebar}
                  >
                    <span className="material-symbols-outlined">
                      person_check
                    </span>{" "}
                    <span className="ml-3">Assigned Institution</span>
                  </Link>
                </li>
                {/* Users Item */}
                {user.role !== "Sales Team" && (
                <>
                  {role === "Admin" && renderUsersTab()}

                  {user.role === "Sales Manager" && (
                    <li>
                      <Link
                        to="/users"
                        className="navbar-item text-base font-normal text-gray-900"
                        onClick={closeSidebar}
                      >
                        <span className="material-symbols-outlined">person</span>
                        <span className="ml-3">Users</span>
                      </Link>
                    </li>
                  )}
                </>
              )}
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
};

Navbar.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
  closeSidebar: PropTypes.func.isRequired,
};

export default Navbar;
